import React from 'react';
import { useSelector } from 'react-redux';
import { motion } from 'framer-motion';

import styles from './Home.module.scss';
// import ICONS from '../../static/media/icons/icons-helper';
import { containerAnimationConfig } from '../../utils/animations-configs';
import HomeNavigationButton from '../../components/home-navigation-button/HomeNavigationButton';
import { getCompleteMenuButtonsByMenuList } from '../../utils/menu-utils';
import {
  menuListSelector,
  copyListSelector,
  getIsLoadingMenuList,
  getIsLoadingCopiesList,
} from '../../redux/selectors/common-selectors';

import { HOME_TITLE, HOME_SUBTITLE } from '../../enums/copies-keys';

const Home = () => {
  const isLoadingMenu = useSelector(getIsLoadingMenuList);
  const isLoadingCopies = useSelector(getIsLoadingCopiesList);
  const menuList = useSelector(menuListSelector);
  const copiesList = useSelector(copyListSelector);
  const buttons = getCompleteMenuButtonsByMenuList(menuList);

  return (
    <div className={styles.contentWrapper}>
      <div className={styles.upperLine} />
      <h1>{copiesList[HOME_TITLE]}</h1>
      <p>{copiesList[HOME_SUBTITLE]}</p>
      {!isLoadingMenu && !isLoadingCopies && (
        <motion.div
          initial="hidden"
          animate="visible"
          variants={containerAnimationConfig()}
        >
          {buttons.map((item, index) => (
            <HomeNavigationButton
              key={index.toString()}
              title={item.title}
              path={item.path}
              icon={item.icon}
            />
          ))}
        </motion.div>
      )}
    </div>
  );
};

export default Home;
